<template>
	<div class="stepper theming tertiary-color">
		<div class="container-lg px-0">
			<div class="row">
				<div class="col-md-24">
					<div class="d-flex flex-row stepper-m">
						<div class="stepper__steps flex-grow-1" v-for="(step, index) in steps" :key="index">
							<!-- <div v-if="index > 0" class="stepper__steps__line current">
								<hr>
							</div> -->
							<div class="stepper__steps__step">
								<router-link
									v-if="!isApplicationStepLinkDisabled(step.num)"
									:to="getRoute(step.num)"
									class="stepper__steps__step__icon"
									:class="[(step.num === currentStepNum) ? 'current' : '']">
									{{ step.num + 1 }}
								</router-link>
								<span
									v-else
									class="stepper__steps__step__icon stepper__steps__step__icon--disabled"
									:class="[(step.num === currentStepNum) ? 'current' : '']"
									aria-disabled="true"
									title="Save the application before opening this step">
									{{ step.num + 1 }}
								</span>

							<div class="stepper__steps__step__label">
								<p class="fw-bold">{{ step.label ? step.label : stepLabels[step.num] }}</p>
							</div>
							</div>
						<div v-if="index < (steps.length - 1)" class="stepper__steps__line current">
							<hr>
						</div>
						<div v-else class="stepper__steps__line" style="visibility: hidden;">
							<hr>
						</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- <mdb-card class="under-nav">
			<mdb-container>
				<mdb-card-body class="px-sm-0">

					<div class="steps-form">
						<div class="steps-row">

							<div v-for="(step, index) in steps" :key="index" class="steps-step">

								<router-link
									v-if="compare(step.num) === 1"
									:to="getRoute(step.num)"
									type="button"
									class="btn btn-circle btn-white btn-outline-primary"
								>{{ step.num }}</router-link>

								<router-link
									v-else-if="compare(step.num) === -1"
									:to="getRoute(step.num)"
									type="button"
									class="btn btn-circle btn-info"
								><icon name="done" type="ma" /></router-link>

								<router-link
									v-else
									:to="getRoute(step.num)"
									type="button"
									class="btn btn-circle btn-info"
								>{{ step.num }}</router-link>

								<p>{{ step.label ? step.label : step.name }}</p>

							</div>

						</div>
					</div>

				</mdb-card-body>
			</mdb-container>
		</mdb-card>


		<div class="stepper theming tertiary-color">
			<div class="container-lg px-0">
				<div class="row">
					<div class="col-md-24">
						<div class="stepper__steps">
							<div class="stepper__steps__step">
								<div class="stepper__steps__step__icon">
									1
								</div>
								<div class="stepper__steps__step__label">
									<p>Applicants</p>
								</div>
							</div>
							<div class="stepper__steps__line current">
								<hr>
							</div>
							<div class="stepper__steps__step">
								<div class="stepper__steps__step__icon current">
									2
								</div>
								<div class="stepper__steps__step__label current">
									<p>Details</p>
								</div>
							</div>
							<div class="stepper__steps__line">
								<hr>
							</div>
							<div class="stepper__steps__step">
								<div class="stepper__steps__step__icon">
									3
								</div>
								<div class="stepper__steps__step__label">
									<p>Equipment</p>
								</div>
							</div>
							<div class="stepper__steps__line">
								<hr>
							</div>
							<div class="stepper__steps__step">
								<div class="stepper__steps__step__icon">
									4
								</div>
								<div class="stepper__steps__step__label">
									<p>Review and Submit</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
</template>

<script>

import { mapState } from 'vuex';

let stepsLabel = [
	'Calculator',
	'Applicants',
	'Equipment',
	'Submit'
]

let guestStepsLabel = [
	'Applicant',
	'Review and Submit'
]

const phase2RouteNames = [
	'Sign',
	'BankVerification',
	'CompletionCertificate',
	'UploadFiles',
	'ApplicationDashboard',
];

let phase2 = [
	'Sign',
	'Bank Verification',
	'Completion',
	'Uploads',
	'Review & Submit',
]

let phase2Components = [
	'Sign',
	'BankVerification',
	'CompletionCertificate',
	'UploadFiles',
	'ApplicationDashboard'
]

let labels = {
	Sign: 'Sign',
	BankVerification: 'BankVerification',
	UploadFiles: 'Upload',
	CompletionCertificate: 'Completion',
	ApplicationDashboard: 'ApplicationDashboard',
}

export default {

	props: {

		app: {
			type: Object,
			default: null
		},

		current: {
			type: [String, Number],
			default: 0
		},

		total: {
			type: Number,
			default: 3
		},

		scan: {
			type: Boolean,
			default: false
		},

		label: {
			type: String,
			default: ''
		}

	},

	data() {

		return {
			applicationId: null,
			stepsActivationFlag: false,
			isLeaseFlag: null,
		};

	},

	computed: {

		...mapState({
			application: state => state.application.info
		}),

		effectiveApplicationId() {
			const p = this.$route.params && this.$route.params.applicationId;
			if (p !== undefined && p !== null && String(p).trim() !== '') {
				return p;
			}
			if (this.applicationId) {
				return this.applicationId;
			}
			return null;
		},

	currentStepNum() {
		
		// Check if we're in phase2 mode
		const isPhase2 = phase2RouteNames.includes(this.$route.name);
		
		if (isPhase2) {
			// Find the index of the current route in phase2Components
			const routeIndex = phase2Components.indexOf(this.$route.name);
			return routeIndex >= 0 ? routeIndex : 0;
		}
		
		// For non-phase2 routes, use the current prop or parse from route
		if (['GuestApplication', 'GuestApplicationReview'].includes(this.$route.name)) {
			return this.$route.name === 'GuestApplicationReview' ? 1 : 0;
		}
		
		// For regular application steps
		if (['PaymentCalculator', 'LeaseCalculator'].includes(this.$route.name)) {
			return 0;
		}
		
		if (this.$route.name === 'ApplicationStep1') return 1; // legacy mapping
		if (this.$route.name === 'ApplicationStep2') return 1;
		if (this.$route.name === 'ApplicationStep3') return 2;
		if (this.$route.name === 'ApplicationStep4') return 3;
		
		// Fallback to parsing from current prop
		return parseInt(this.current.toString().substr(0, 1)) || 0;
		
	},

	steps() {

		let steps = [];
		
		// Check if we're in phase2 mode
		const isPhase2 = phase2RouteNames.includes(this.$route.name);
		
		// Generate 5 steps for phase2 (0-4), 4 steps otherwise (0-3)
		const maxStep = isPhase2 ? 4 : 3;
		
		for (let i = 0; i <= maxStep; i++) {

			steps.push({
				num: i,
				name: i ? this.$i18n.t('forms.steps', { step: i }) : this.$i18n.t('forms.scan'),
				label: this.label && isPhase2 ? labels[phase2Components[i]] : ''
			});

		}

		return steps;

	},

		stepLabels() {

			if (['GuestApplication', 'GuestApplicationReview'].includes(this.$route.name)) {
				return guestStepsLabel
			}
			
			if (phase2RouteNames.includes(this.$route.name)) {
				// console.log();
				return phase2
			}

			return stepsLabel
		}

	},

	watch: {

		application: {
			handler(val) {

				if (!val || !val.data || !val.data.id) {

					return;

				}

				this.applicationId = val.data.id;

			},
			deep: true,
			immediate: true
		}

	},

mounted() {

	// Ensure we have applicationId from route if not set
	if (!this.applicationId) {
		const routeId = this.$route && this.$route.params && this.$route.params.applicationId;
		if (routeId) {
			this.applicationId = routeId;
		}
	}

	// If app prop provided, derive applicationId
	if (this.app) {
		const id = (this.app.data && this.app.data.id) || this.app.id;
		if (id) this.applicationId = id;
	}

},

	methods: {

		/** Disable Applicants (1), Equipment (2), Submit (3) until a real application id exists */
		isApplicationStepLinkDisabled(stepNum) {
			if (![1, 2, 3].includes(stepNum)) {
				return false;
			}
			if (['GuestApplication', 'GuestApplicationReview'].includes(this.$route.name)) {
				return false;
			}
			if (['Sign', 'BankVerification', 'UploadFiles', 'CompletionCertificate', 'ApplicationDashboard'].includes(this.$route.name)) {
				return false;
			}
			const id = this.effectiveApplicationId;
			return !id || id === 'new';
		},

		isLeaseProgram() {
			// Determine lease vs loan using provided app or store
			let program = null;
			const sourceApp = this.app || this.application;
			console.log('[Steps] sourceApp =>', !!sourceApp);
			if (sourceApp) {
				// Prefer top-level program first
				if (sourceApp.program) {
					program = sourceApp.program;
				} else if (sourceApp.application && sourceApp.application.program) {
					program = sourceApp.application.program;
				} else if (sourceApp.data && sourceApp.data.program) {
					program = sourceApp.data.program;
				} else if (sourceApp.data && sourceApp.data.application && sourceApp.data.application.program) {
					program = sourceApp.data.application.program;
				}
			}
			
			if (program) {
				const code = (program && program.Code) || (program && program.program && program.program.Code) || null;
				const numericCode = code != null ? Number(code) : null;
				const leaseMonths = program.leaseTermMonths != null ? Number(program.leaseTermMonths) : null;
				const isLease = (program.programType === 'Lease') || (numericCode === 2) || (leaseMonths != null && leaseMonths > 0);
				console.log('[Steps.isLeaseProgram] code:', code, 'numericCode:', numericCode, 'leaseTermMonths:', leaseMonths, 'isLease:', isLease);
				return isLease;
			}
			
			if (this.isLeaseFlag !== null) {
				console.log('[Steps.isLeaseProgram] fallback isLeaseFlag:', this.isLeaseFlag);
				return this.isLeaseFlag;
			}
			return false;
		},

		compare(num) {

			let current = parseInt(this.current.toString().substr(0, 1));

			if (current < num) {

				return 1;

			}

			if (current > num) {

				return -1;

			}

			return 0;

		},

		getRoute(num) {

			if (['GuestApplication', 'GuestApplicationReview'].includes(this.$route.name)) {
				
				return {
					name: num == 1 ? 'GuestApplication' : 'GuestApplicationReview',
					params: this.$route.params,
					query: this.$route.query
				}
				
				return {
					name: 'GuestApplication',
					params: this.$route.params,
					query: {
						token: this.$route.query.token,
						page: num == 1 ? 'input' : 'review'
					}
				};

			}

			if (phase2RouteNames.includes(this.$route.name)) {
				return {
					name: phase2Components[num],
					params: this.$route.params,

				};
			}

			let defaultParams = {
				applicationId: this.applicationId
			};
			let params = (this.$route.params && this.$route.params.applicationId) ? this.$route.params : defaultParams;

			// Map step number to route name
			// Step 0 = PaymentCalculator or LeaseCalculator (Program)
			// Step 1 = ApplicationStep1 (Applicants)
			// Step 2 = ApplicationStep2 (Details)
			// Step 3 = ApplicationStep3 (Equipment)
			// Step 4 = ApplicationStep4 (Submit/Confirmation)
			
			let routeName;
			
			// For step 0 (Program), determine if it's a lease or loan
			if (num === 0) {
				// Check application data to determine calculator type
				// Default to PaymentCalculator for loans
				routeName = this.isLeaseProgram() ? 'LeaseCalculator' : 'PaymentCalculator';
				console.log("this.isLeaseProgram() ==> ", this.isLeaseProgram());
				console.log("routeName ==> ", routeName);
			} else {
				let routeMap = {
				1: 'ApplicationStep2', // Applicants
				2: 'ApplicationStep3', // Equipment
				3: 'ApplicationStep4'  // Submit
				};
				
				routeName = routeMap[num];
			}
			
			if (!routeName) {
				// Fallback to ApplicationStep1
				routeName = 'ApplicationStep1';
			}

			// Ensure Program link carries applicationId
			if (routeName === 'LeaseCalculator') {
				console.log('LeaseCalculator', params);
				const idVal = params.applicationId || this.applicationId;
				return {
					name: routeName,
					params: { applicationId: idVal }
				};
			}

			return {
				name: routeName,
				params
			};

		}

	}

};

</script>

<style lang="scss" scoped>
/* All sizes: icons level & labels centered */
.stepper-m {
	justify-content: space-evenly;
}

.stepper__steps__step {
	justify-content: flex-start !important;
}

.stepper__steps {
	&:first-child .stepper__steps__step {
		margin-right: 0 !important;
	}
	&:last-child .stepper__steps__step {
		margin-left: 0 !important;
	}
}

.stepper__steps__step__label p {
	text-align: center;
}

.stepper__steps__step__icon--disabled {
	cursor: not-allowed;
	opacity: 0.45;
	pointer-events: none;
}

/* Mobile: compact stepper */
@media (max-width: 991px) {
	.stepper-m {
		margin-left: 0 !important;
	}

	.stepper__steps__line {
		display: none !important;
	}

	.stepper {
		min-height: auto !important;
		padding-top: 16px !important;
		padding-bottom: 12px !important;
	}

	.stepper__steps__step__icon {
		height: 28px !important;
		width: 28px !important;
		font-size: 0.75rem !important;
		margin-bottom: 6px !important;
	}

	.stepper__steps__step__label p {
		font-size: 0.625rem !important;
		margin-bottom: 0;
	}
}

/* Desktop: keep original line visibility */
@media (min-width: 992px) {
	.stepper__steps__line {
		display: flex;
	}
}

.steps-form .steps-row {
	width: 100%;
	display: flex;
	justify-content: space-between;
	color: $blue;

	&:before {
		top: 20px;
		left: 10px;
		right: 10px;
		width: auto;
		height: 2px;
		background-color: $blue;
	}

	.steps-step {
		display: block !important;

		@media all and (-ms-high-contrast:none) {
			margin-left: auto;
			margin-right: auto;
		}

		.btn-circle {
			opacity: 1 !important;
			font-size: 1rem;
			font-weight: bold;
			padding: 8px 0;
			width: 2.5rem;
			height: 2.5rem;
			border-radius: 2rem;
			box-shadow: none;
			margin-right: 0;
			margin-left: 0;

			&.btn-info {
				padding: 9px 0;

				&:before {
					position: absolute;
					top: 20px;
					left: 10px;
					right: 10px;
					width: auto;
					height: 2px;
					background-color: $blue;
				}
			}

			&.btn-white.btn-outline-primary {

				&,
				&:hover,
				&:focus,
				&:active {
					background: $white !important;
				}
			}
		}

	}

}
</style>
